import { render, staticRenderFns } from "./SafetyTrainingSignUp.vue?vue&type=template&id=4bed1efb"
import script from "./SafetyTrainingSignUp.vue?vue&type=script&lang=js"
export * from "./SafetyTrainingSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports